import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

type DMDialogProps = {
  triggerContent?: React.ReactNode;
  content: React.ReactNode;
  dialogTitle?: string;
  className?: string;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  outSideClickClose?: boolean;
};

function DMDialog({
  triggerContent,
  content,
  dialogTitle,
  className,
  open,
  setOpen,
  outSideClickClose = true,
}: DMDialogProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined && setOpen !== undefined;

  const handleOpenChange = (state: boolean) => {
    if (isControlled) {
      setOpen(state);
    } else {
      setInternalOpen(state);
    }
  };

  return (
    <Dialog open={isControlled ? open : internalOpen} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <button onClick={() => handleOpenChange(true)}>{triggerContent}</button>
      </DialogTrigger>
      <DialogContent
        className={cn('bg-brand-secondary border-none !p-0 rounded-md', className)}
        onInteractOutside={event => {
          outSideClickClose ? '' : event.preventDefault();
        }}
      >
        <DialogHeader>
          {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
          <DialogDescription className='h-full w-full relative'>{content}</DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

export default DMDialog;
